import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    STROLLER_ALL_REVIEWS_GALLERY_FETCH_TRIGGER,
    StrollerAllReviewsGalleryFetchNormalizedResponse,
    StrollerAllReviewsGalleryFetchTriggerAction,
    strollerAllReviewsGalleryFetchApi,
} from "@/mk2/apps/strollers/containers/StrollerAllReviewsGallery/StrollerAllReviewsGallery.actions";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { strollers_api_v2_reviews_photos_get_url } from "@/mk/urls/functions";

const logger = getLogger("strollers/StrollerAllReviewsGallery.sagas");

interface FetchApiResponse {
    body: StrollerAllReviewsGalleryFetchNormalizedResponse;
}

function* fetchStrollerReviews({
    strollerSlug,
    xhr,
}: StrollerAllReviewsGalleryFetchTriggerAction & XHRAction) {
    yield put(strollerAllReviewsGalleryFetchApi.request(strollerSlug));

    try {
        const response: FetchApiResponse = yield call(() =>
            xhr.get(strollers_api_v2_reviews_photos_get_url({ strollerSlug })),
        );

        yield put(strollerAllReviewsGalleryFetchApi.success(strollerSlug, response.body));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(strollerAllReviewsGalleryFetchApi.failure(strollerSlug, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(STROLLER_ALL_REVIEWS_GALLERY_FETCH_TRIGGER, fetchStrollerReviews)]);
}
